import ButtonCardContainer from './ButtonCardContainer';
import ButtonCardUI from './ButtonCardUI';
var ButtonCard = {
    Container: ButtonCardContainer,
    UI: ButtonCardUI
};
export default ButtonCard;
